import { styled, css, Typography, Stack, Chip } from '@mui/material';
import { theme } from 'assets/themes/zizzi';

const fadeEdgesWidth = '10px';

const fadeEdges = css`
  background: linear-gradient(90deg, rgba(255, 255, 255, 1) 30%, rgba(255, 255, 255, 0) 100%);
  content: '';
  height: 100%;
  position: absolute;
  top: 0;
  width: ${fadeEdgesWidth};
  z-index: 1;
`;

export const Label = styled(Typography)`
  align-items: center;
  color: ${theme.palette.primary.main};
  display: flex;
  position: relative;

  &:after {
    ${fadeEdges};
    right: -${fadeEdgesWidth};
  }
`;

export const Wrapper = styled('div')`
  display: flex;
  flex-direction: row;
  padding: 0.5rem 0;
  position: relative;

  &:after {
    ${fadeEdges};
    right: 0;
    transform: rotate(180deg);
  }
`;

export const TagList = styled(Stack)`
  overflow-x: scroll;
  padding: 0 ${fadeEdgesWidth};
  scrollbar-width: none;

  ::-webkit-scrollbar {
    display: none;
  }
`;

export const Tag = styled(Chip)``;
